import { Outlet, useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { ActiveOrderHeaderButton } from "./ActiveOrderHeaderButton";
import { useNotifications } from "@/hooks/useNotifications";

export function AppShell() {
  const location = useLocation();

  // Request FCM permission & listen for foreground push messages
  useNotifications();

  const hideNav =
    location.pathname === "/" ||
    location.pathname === "/onboarding" ||
    location.pathname.startsWith("/order/");

  return (
    <div className="min-h-dvh gradient-warm flex flex-col relative">
      <ActiveOrderHeaderButton />
      <main className={`flex-1 mx-auto w-full max-w-md ${hideNav ? "pb-4" : "pb-28"}`}>
        <div key={location.pathname} className={location.pathname === "/scan" ? "h-full" : "animate-fade-in-up"}>
          <Outlet />
        </div>
      </main>
      {!hideNav && <BottomNav />}
    </div>
  );
}
